var map = {
	"./logo-website-squarespace.de.json": 47745,
	"./logo-website-squarespace.en.json": 97082,
	"./logo-website-squarespace.es.json": 45176,
	"./logo-website-squarespace.fr.json": 158,
	"./logo-website-squarespace.it.json": 1424,
	"./logo-website-squarespace.ja.json": 16844,
	"./logo-website-squarespace.nl.json": 94919,
	"./logo-website-squarespace.pt.json": 91276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89471;